<template functional>
  <SocialImage
    title="Blip"
    v-bind="data.attrs"
    :class="[data.class, data.staticClass]"
    channel="blip"
    v-on="listeners"
  />
</template>

<script>
import SocialImage from './SocialImage';

export default {
  name: 'BlipImage',
  components: {
    SocialImage,
  },
};
</script>

